export { getAuth0Handler } from './auth0.provider';
export * from './auth0-session.service';
export * from './auth0-tokens.service';
export { AccessTokenError } from '@auth0/nextjs-auth0';
export { useUser, UserProvider } from '@auth0/nextjs-auth0/client';
export type { UserProfile } from '@auth0/nextjs-auth0/client';
